/**
 * Badge padrão de mercado para App Store e Google Play.
 * Usa imagens de frontend/public/images/applestore.png e googleplay.png.
 */

import React from 'react';
import { Box } from '@mui/material';

export type StoreType = 'app-store' | 'google-play';

interface StoreBadgeButtonProps {
  type: StoreType;
  onClick: () => void;
  'aria-label': string;
}

const storeConfig: Record<StoreType, { src: string; alt: string }> = {
  'app-store': {
    src: '/images/applestore.png',
    alt: 'App Store',
  },
  'google-play': {
    src: '/images/googleplay.png',
    alt: 'Google Play',
  },
};

const StoreBadgeButton: React.FC<StoreBadgeButtonProps> = ({ type, onClick, 'aria-label': ariaLabel }) => {
  const { src, alt } = storeConfig[type];

  return (
    <Box
      component="button"
      onClick={onClick}
      aria-label={ariaLabel}
      sx={{
        display: 'block',
        p: 0,
        border: '1px solid #dadce0',
        borderRadius: 1.5,
        cursor: 'pointer',
        bgcolor: 'transparent',
        transition: 'opacity 0.2s, border-color 0.2s',
        '&:hover': {
          opacity: 0.9,
          borderColor: '#bdc1c6',
        },
        font: 'inherit',
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{
          display: 'block',
          height: 44,
          width: 135,
          objectFit: 'contain',
        }}
      />
    </Box>
  );
};

export default StoreBadgeButton;
